import React, { useEffect, useState } from 'react'
import { WrapperDaftarTugas, ListTugas } from '../dashboard-employee.elements'
import API from '../../../../config/api';
import { TaskContainer } from '../components/tambahTugas';
import { Loading } from '../../../../components';
import { Amount, Card, CardContent, CardLeft, CardRight, ReimbursementContainer, Status, TextDate, Title } from '../components/reimbursement';

//nanti refactor kode ini supaya bisa digunakan di mana aja
const Reimbursement = ({ setOpenmodal, setData, status, search, reimbursement, setTicket, getReimbursement, setTypeModal }) => {
    const [todos, setTodos] = useState([]);
    const [text, setText] = useState({});
    const [edit, setEdit] = useState({
        id: null,
        value: ''
    });
    const token = localStorage.getItem('token');
    const [loading, setLoading] = useState(false)
    const [visibleCount, setVisibleCount] = useState(5);

    const handleLoadMore = () => {
        setVisibleCount(prev => prev + 5);
    };



    const updateTodo = (todoId, newValue) => {
        // console.log(newValue)

        if (!newValue.text || /^\s*$/.test(newValue.text)) {
            return;
        }

        setTodos(prev => prev.map(item => (item.id === todoId ? newValue : item)));
    }

    const submitUpdate = value => {
        updateTodo(value.id, value);
        setEdit({
            id: null,
            value: ''
        })
    }

    if (edit.id) {
        // console.log(`isi form tambah itu dengan ${edit}`);
        setText(edit)
        setEdit({
            id: null,
            value: ''
        })
    }
    const formatRupiah = (number) => {
        return new Intl.NumberFormat("id-ID", {
            style: "currency",
            currency: "IDR",
            minimumFractionDigits: 0
        }).format(number);
    };

    const formatTanggalIndonesia = (tanggalString) => {
        const tanggal = new Date(tanggalString);
        return new Intl.DateTimeFormat('id-ID', {
            weekday: 'long',
            day: '2-digit',
            month: 'long',
            year: 'numeric'
        }).format(tanggal);
    };


    return (
        <>
            <ReimbursementContainer>
                {reimbursement?.slice(0, visibleCount)?.map((re, index) => (
                    <Card key={index} onClick={() => {
                        setTypeModal('Detail')
                        setOpenmodal(true)
                        setData(re)
                    }}>
                        <CardContent>
                            <Title>{re?.title}</Title>
                            <Amount>{formatRupiah(re?.amount)}</Amount>
                        </CardContent>
                        <CardContent>
                            <Status className={re?.status === 'approved' || re?.status === 'paid' ? "approved" : re?.status === 'pending' ? "submitted" : "rejected"}>{re?.status}</Status>
                            <TextDate>{formatTanggalIndonesia(re?.date_incurred)}</TextDate>
                        </CardContent>
                    </Card>
                ))}
                {visibleCount < reimbursement?.length && (
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <button onClick={handleLoadMore} style={{ marginTop: '10px', fontWeight: "600", fontSize: "20px" }}>
                            Load More
                        </button>
                    </div>
                )}


                {loading && <Loading />}
            </ReimbursementContainer >
        </>
    )
}

export default Reimbursement
